module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADnSURBVHgBtZG/zgFBFMXnzjefeh4BpYZKlCtIlDZIdKJDgycQpY4GiUYpQbKlBOEBJFRKmUfY2s7uNVNINvG/cIqbuTm/3Jw7F4hPqXwtR4E2CGAQEWxEr7NZDK2bT2+PTLEeA6BtR/6bq9kgJJlr6j5dqBp3MCJpA1wqO6tn6343HQlC3BYiLd/BhABfzcZHfyzGiAAV6QH8XqCLkWtyxpytmtL3m2pJrmqZSc9cWiMB2VI1KCU9KI+/GGoDOEnqutR4A2pxzwtEv8r8Q1idVHwCqp+y/86nvQhH4nrBxHMQJuv5oHsFws5Nim4coPEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/document-lock.png
// module id = 1886
// module chunks = 2